import { render, staticRenderFns } from "./SwitchesShow.vue?vue&type=template&id=44660879&"
import script from "./SwitchesShow.vue?vue&type=script&lang=js&"
export * from "./SwitchesShow.vue?vue&type=script&lang=js&"
import style0 from "./SwitchesShow.vue?vue&type=style&index=0&id=44660879&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports